import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { tap } from 'rxjs';
import { Branch } from '../../../../core/interfaces/total-reports/branch.interface';
import { BranchService } from '../../../../core/services/branch/branch.service';
import { LoadBranchesForBrand } from './branches.actions';
import { BranchesStateModel } from './branches.model';

@Injectable()
@State<BranchesStateModel>({
    name: 'branchesState',
    defaults: {
        branchesByBrand: {},
    },
})
export class BranchesState {
    constructor(private readonly branchService: BranchService) {}

    @Selector()
    static getBranchesByBrand(state: BranchesStateModel): Record<number, Branch[]> {
        return state.branchesByBrand;
    }

    static getBranchesForBrand(brandId: number) {
        return (state: { branchesState: BranchesStateModel }): Branch[] =>
            state.branchesState?.branchesByBrand?.[brandId] ?? [];
    }

    @Action(LoadBranchesForBrand)
    loadBranchesForBrand(ctx: StateContext<BranchesStateModel>, { brandId }: LoadBranchesForBrand) {
        const existing = ctx.getState().branchesByBrand[brandId];
        if (existing) {
            return;
        }
        return this.branchService.getBranch().pipe(
            tap((branches) => {
                ctx.patchState({
                    branchesByBrand: {
                        ...ctx.getState().branchesByBrand,
                        [brandId]: branches,
                    },
                });
            }),
        );
    }
}
